import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Dialog, IconButton, styled } from '@mui/material';

export const InfoIcon = styled(InfoOutlinedIcon)(({ theme }) => ({
	width: '16px',
	height: '16px',
	color: theme.palette.primary.main,
	cursor: 'pointer',
}));

export const RuleModal = styled(Dialog, {
	shouldForwardProp: (prop) => prop !== 'isStudent',
})<{ isStudent?: boolean }>(({ isStudent }) => ({
	'& .MuiDialog-container > .MuiPaper-root': {
		maxWidth: 'min(700px, 95%)',
		padding: '24px',

		...(!isStudent
			? {
					borderRadius: '20px',
					minWidth: '700px',
					backgroundColor: '#F3F9FF',
				}
			: {}),
	},
}));

export const Header = styled('div', {
	shouldForwardProp: (prop) => prop !== 'isStudent',
})<{ isStudent?: boolean }>(({ isStudent }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '16px',
	justifyContent: 'space-between',
	marginBottom: '8px',

	'& > h2': {
		...(!isStudent
			? {
					fontSize: '24px',
					fontWeight: '600',
					lineHeight: '32px',
					letterSpacing: '0.15px',
					padding: '0',
				}
			: {}),
	},
}));

export const CloseWrap = styled(IconButton)({
	width: '32px',
	height: '32px',
	borderRadius: '50%',
	background: '#FFFFFFB2',
});
